import React, { RefObject } from 'react';

export type RefElementType = RefObject<HTMLDivElement> | null;

/**
 * Context to provide ability to set page change alerts from anywhere
 *
 * @interface VisuallyHiddenAnnouncementContext
 */
interface VisuallyHiddenAnnouncementContext {
	setAlert: (message: string) => void;
	mainRef: RefElementType;
	setMainRef: (value: RefElementType) => void;
}

export default React.createContext<VisuallyHiddenAnnouncementContext>({} as VisuallyHiddenAnnouncementContext);
